import { SincePeriod } from '@xing-com/crate-common-graphql-types';

export const SINCE_PERIOD_KEY: Record<SincePeriod, string> = {
  [SincePeriod.Last_24Hours]: 'JOBS_SEARCH_FILTER_TIME_FRAME_LAST_24_HOURS',
  [SincePeriod.LastWeek]: 'JOBS_SEARCH_FILTER_TIME_FRAME_LAST_WEEK',
  [SincePeriod.LastMonth]: 'JOBS_SEARCH_FILTER_TIME_FRAME_LAST_MONTH',
};
